import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox"
import * as types from "../../constants/actionTypes";
import moment from 'moment';
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST, PUT } from "../../service/api";
import { Header } from '../../constants/headers';
import { setLoader } from "./actions";


const getStateModulePoli = state => state.ModulePoli;

export function* getMasterData() {
    try {
        yield put({ type: types.MODULE_POLI_SET_LOADER, value: true})
        let _body = {
            MasterData: [
                {
                    ObjectName: "listPoliklinik",
                },
            ]
        }
        const response = yield call(POST, Config.BASE_URL + Endpoint.GET_LIST_MASTER_DATA, _body)
        yield all(
            yield put({ type: types.MODULE_POLI_MASTER_DATA_SUCCESS, property: 'listPoliklinik', value: response.data.listPoliklinik}),
        )

        yield put({ type: types.MODULE_POLI_SET_LOADER, value: false})
    } catch (error) {
        yield put({ type: types.MODULE_POLI_SET_LOADER, value: false})
        messages("Error", error, "error", false, false);
    }
}

export function* getDataPoli(params) {
    try {
        // yield put({ type: types.MODULE_POLI_SET_LOADER, value: true})
        yield put(setLoader(true));

        let stateModule = yield select(getStateModulePoli)

        const _id = JSON.parse(localStorage.getItem('UserData')).f_id_klinik;

        if(params.value == "all"){
            const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_POLI_LIST_GET + _id);

            if(response.acknowledge == 1){
                yield put({ type: types.MODULE_POLI_DATA_GET_ALL_SUCCESS, value: response.data})
            }else{
                messages("Error", "Gagal memuat data", "error", false, false);
            }
        }else if(params.value >= 0){
            const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_POLI_DETAIL_GET + params.value);
            if(response.acknowledge == 1){
                const _data = response.data
                const _formDetail= {
                    "f_id_klinik_poliklinik": _data.f_id_klinik_poliklinik,
                    "f_id_klinik": _data.f_id_klinik,
                    "f_id_poliklinik": _data.f_id_poliklinik,
                    "f_status_poliklinik": _data.f_status_poliklinik == 1 ? true : false,
                }
                yield put({ type: types.MODULE_POLI_DATA_GET_DETAIL_SUCCESS, value: _formDetail})
            }else{
                messages("Error", "Gagal memuat data", "error", false, false);
            }
        }else{
            messages("Error", "Gagal memuat data", "error", false, false);
        }

        yield put({ type: types.MODULE_POLI_SET_LOADER, value: false})
    } catch (error) {
        yield put({ type: types.MODULE_POLI_SET_LOADER, value: false})
        messages("Error", error, "error", false, false);
    }
}

export function* postForm(params) {
    try {
        yield put({ type: types.MODULE_POLI_SET_LOADER, value: true})         

        let stateModule = yield select(getStateModulePoli)
        const _data = stateModule.formPoli

        const _body = {
            "f_id_klinik_poliklinik": _data.f_id_klinik_poliklinik,
            "f_id_klinik": JSON.parse(localStorage.getItem('UserData')).f_id_klinik,
            "f_id_poliklinik": _data.f_id_poliklinik,
            "f_status_poliklinik": _data.f_status_poliklinik == true ? 1 : 0,
        }

        if(!params.value){
            const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_POLI_CREATE_POST, _body, { headers: Header() });
            if (response.acknowledge == 1) {
                yield put({ type: types.MODULE_POLI_SET_LOADER, value: false})         
                messages("Berhasil", response.message, "success", false, params.history);
            }else{
                messages("Error", response.message, "error", false, false);
            }
        }else{
            const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_POLI_UPDATE_POST, _body, { headers: Header() });
            if (response.acknowledge == 1) {
                messages("Berhasil", response.message, "success", false, params.history);
            }else{
                messages("Error", response.message, "error", false, false);
            }
        }

        yield put({ type: types.MODULE_POLI_SET_LOADER, value: false})         
        
    } catch (error) {
        yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: false})         
        messages("Error", error, "error", false, false);
    }
}


export default function* rootSaga() {
    yield all([
        takeLatest(types.MODULE_POLI_DATA_GET, getDataPoli),
        takeLatest(types.MODULE_POLI_MASTER_DATA, getMasterData),
        takeLatest(types.MODULE_POLI_SUBMIT_FORM, postForm),
    ]);
}